<template>
  <div
    class="h-full flex-1 flex flex-col items-center justify-center bg-cover bg-center bg-no-repeat"
    :style="{ backgroundImage: `url(${bgImage})` }"
  >
    <div class="absolute w-full h-full inset-0 bg-black bg-opacity-50"></div>
    <!-- <div
      class="login-container flex-1 bg-white border border-gray-300 rounded-lg p-4 max-w-md mx-auto hidden"
    >
      <h1>register</h1>
      <form @submit.prevent="handleRegister">
        <div>
          <label>Email:</label>
          <input type="email" v-model="email" required />
        </div>
        <div>
          <label>Password:</label>
          <input type="password" v-model="password" required />
          <input
            type="password"
            id="confirmPassword"
            v-model="confirmPassword"
            required
          />
        </div>
        <button type="submit">register</button>
      </form>
    </div> -->
    <div
      class="login-container flex flex-col items-center bg-slate-100 bg-opacity-95 rounded-xl shadow-md p-8 text-center w-full max-w-lg mx-auto relative z-10"
    >
      <div>
        <img src="assets/img/meditationcircle-logo.svg" alt="" />
      </div>
      <h1 class="text-lg sm:text-2xl font-semibold text-brand mb-6">Login</h1>
      <form @submit.prevent="handleLogin" class="flex flex-col gap-4 w-full mx-auto">
        <input
          placeholder="Your Email"
          class="flex-1 border border-gray-300 rounded-md shadow-sm p-3 bg-white text-gray-800 placeholder:text-gray-500"
          type="email"
          v-model="email"
          required
        />
        <input
          placeholder="Your Password"
          class="flex-1 border border-gray-300 rounded-md shadow-sm p-3 bg-white text-gray-800 placeholder:text-gray-500"
          type="password"
          v-model="password"
          required
        />
        <button
          class="bg-brand border border-white text-white font-semibold py-3 px-6 rounded-md shadow-md hover:bg-brand-light transition-colors duration-300"
          type="submit"
          :disable="isLogging"
        >
          {{ isLogging ? "Logging..." : "Login" }}
        </button>
        <div class="text-center mt-2">
          <a
            href="#"
            @click.prevent="showResetPasswordModal = true"
            class="text-brand hover:text-brand-light text-sm"
            >Forgot your password?</a
          >
        </div>
      </form>

      <!-- Password Reset Modal -->
      <div
        v-if="showResetPasswordModal"
        class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-20"
      >
        <div class="bg-white rounded-lg p-6 w-full max-w-md">
          <h2 class="text-xl font-semibold mb-4">Reset Password</h2>
          <div v-if="resetEmailSent" class="mb-4 p-3 bg-green-100 text-green-700 rounded">
            We've sent a password reset link to your email.
          </div>
          <div v-else>
            <p class="mb-4">
              Enter your email address and we'll send you a link to reset your password.
            </p>
            <form @submit.prevent="handleResetPassword" class="flex flex-col gap-4">
              <input
                placeholder="Your Email"
                class="flex-1 border border-gray-300 rounded-md shadow-sm p-3 bg-white"
                type="email"
                v-model="resetEmail"
                required
              />
              <div class="flex gap-2 justify-end">
                <button
                  type="button"
                  @click="showResetPasswordModal = false"
                  class="px-4 py-2 border border-gray-300 rounded-md"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  class="bg-brand text-white px-4 py-2 rounded-md flex items-center gap-2"
                  :disabled="isResettingPassword"
                >
                  <svg
                    v-if="isResettingPassword"
                    class="animate-spin h-5 w-5 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      class="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      stroke-width="4"
                    ></circle>
                    <path
                      class="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  {{ isResettingPassword ? "Sending..." : "Send Reset Link" }}
                </button>
              </div>
            </form>
          </div>
          <div v-if="resetEmailSent" class="flex justify-center mt-4">
            <button
              @click="showResetPasswordModal = false"
              class="px-4 py-2 bg-brand text-white rounded-md"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
definePageMeta({
  layout: "admin",
  layoutTransition: false,
  middleware: []
});

import { reloadNuxtApp } from "nuxt/app";
import meditationBg from "~/assets/img/meditation-stance.webp";

const bgImage = meditationBg;
const client = useSupabaseClient();
const user = useSupabaseUser();

const email = ref("");
const password = ref("");

const confirmPassword = ref("");
const error = ref("");
const supabase = useSupabaseClient();

const resetEmail = ref("");
const showResetPasswordModal = ref(false);
const resetEmailSent = ref(false);
const isResettingPassword = ref(false);
const isLogging = ref(false);

const handleLogin = async () => {
  isLogging.value = true;
  try {
    const { error } = await client.auth.signInWithPassword({
      email: email.value,
      password: password.value
    });
    if (error) throw error;
    // navigateTo('/', {external: true})
    reloadNuxtApp({
      path: "/admin",
      ttl: 1000 // default 10000
    });
  } catch (error) {
    console.error("Error:", error.message);
  } finally {
    isLogging.value = false;
  }
};
const handleRegister = async () => {
  if (password.value !== confirmPassword.value) {
    error.value = "Passwords do not match";
    return;
  }

  try {
    const { data, error: signUpError } = await supabase.auth.signUp({
      email: email.value,
      password: password.value
    });

    if (signUpError) throw signUpError;

    // Redirect to home page or dashboard after successful registration
    navigateTo("/");
  } catch (e) {
    error.value = e.message;
    console.log(e);
  }
};

const handleResetPassword = async () => {
  isResettingPassword.value = true;
  try {
    const { error } = await supabase.auth.resetPasswordForEmail(resetEmail.value, {
      redirectTo: `${window.location.origin}/reset-password`
    });

    if (error) throw error;

    resetEmailSent.value = true;
  } catch (error) {
    console.error("Error sending reset password link:", error.message);
  } finally {
    isResettingPassword.value = false;
  }
};
</script>
